var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base', 'common/location'], function($, core, BaseModel, locationConfig) {
  var LedgerAccountModel;
  return LedgerAccountModel = (function(_super) {

    __extends(LedgerAccountModel, _super);

    function LedgerAccountModel() {
      LedgerAccountModel.__super__.constructor.apply(this, arguments);
    }

    LedgerAccountModel.prototype.pathRoot = core.getConfig().apiPrefix + 'ledgeraccount.json';

    LedgerAccountModel.prototype.defaults = function() {
      return {
        id: null,
        code: null,
        categoryId: null,
        currencyId: typeof core.getCurrentClientCurrencyId === "function" ? core.getCurrentClientCurrencyId() : void 0,
        clientId: typeof core.getCurrentClientId === "function" ? core.getCurrentClientId() : void 0,
        role: null,
        name: '',
        accountType: 'FLAVOUR',
        canBeEdited: true,
        canInfoBeEdited: true,
        canDeleteCauseConflict: false,
        canBeDeleted: true,
        canTransfer: true,
        employee: null,
        isAddOn: null,
        details: null,
        statementDayOfMonth: null,
        active: true
      };
    };

    LedgerAccountModel.prototype.validate = function(attrs) {
      if (_.isEmpty(attrs.name)) {
        return "Ledger name cannot be empty";
      }
    };

    LedgerAccountModel.prototype.reorder = function(toId) {
      return this.customCall('/reorder_to/' + toId, 'PUT');
    };

    LedgerAccountModel.prototype.merge = function(toId) {
      return this.customCall('/merge/' + toId, 'PUT');
    };

    LedgerAccountModel.prototype.isEditable = function() {
      var personCanEdit;
      personCanEdit = core.isCurrentClientBookkeeper() || this.get('code') !== core.getDefaultLedgers()['money.in.transit'].code && this.get('code') !== core.getDefaultLedgers()['money.in.transit.outstanding'].code;
      return this.get('canBeEdited') && personCanEdit;
    };

    LedgerAccountModel.prototype.isBankOrCreditCardAccount = function() {
      return this.get('role') !== null;
    };

    LedgerAccountModel.prototype.isAwaitingCategory = function() {
      return _.contains(['5680', '4500'], this.get('code'));
    };

    return LedgerAccountModel;

  })(BaseModel);
});
